<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>


    <div class="page template-padding" v-else-if="loaded" >
        
        <div class="" >
            <ul class="horizontal-menu" > 
                <li>  <router-link :to="{name: 'Leads'}" class="not-active pl-0" > <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back </router-link>  </li>
            </ul>
        </div>
        
        <div class="" >
            
            <leadDetails :data="data" :type="type" ></leadDetails>
    
        </div>
        
        <div class="page-section mt-4 pl-0" >
            <ul class="horizontal-menu border-bottom-gray font-size-14" > 
                <li>
                    <router-link :to="{name: 'Timeline'}" ref="tags" class=" font-weight-bold" > Customer Journey </router-link>
                </li>
                <li>
                    <router-link :to="{name: 'Clicks'}" class=" font-weight-bold" > Clicks </router-link>
                </li>
                
                <li>
                    <router-link :to="{name: 'Orders'}" class=" font-weight-bold" > Purchases </router-link>
                </li>
                
                <li v-if="userRole == 0" >
                    <router-link :to="{name: 'Events' }" class=" font-weight-bold" > <span class="menu-icon" > <font-awesome-icon :icon="['fab', 'angular']" /> </span> Events </router-link>
                </li>
                
                <li v-if="userRole == 0" >
                    <router-link :to="{name: 'Clicksv2'}" class=" font-weight-bold" > <span class="menu-icon" > <font-awesome-icon :icon="['fab', 'angular']" /> </span> Clicks SQL </router-link>
                </li>
                
                <li v-if="userRole == 0" >
                    <router-link :to="{name: 'Clicksv3'}" class=" font-weight-bold" > <span class="menu-icon" > <font-awesome-icon :icon="['fab', 'angular']" /> </span> Clicks Events </router-link>
                </li>
                
            </ul>
        </div>
        
        <div class="" >
            <router-view :key="$route.path" ></router-view>
        </div>
        
    </div>
</template>

<script>

import leadDetails from '@/components/leadDetails.vue' 
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import helper from '@/helpers/helpers.js';

export default {
    name: 'Lead',
    components:{
        leadDetails
    },
    props: {
        ID: { 
            type: [Number, String],
        }
    },
    data: function(){
        return {
            loaded: false,
            data:{},
            docID: this.ID,
            type: 'page',
            timeout: 50,
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        this.get_data();
        //this.get_customer_stats()
    },
    beforeDestroy() {
    },
    methods: {
        
        get_data(){

            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )

            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads').doc( this.docID )

            return ref.get()
                .then((snapshot) => {
                    //console.log(snapshot.data())
                    if( snapshot.data().mergedLead ){
                        this.$router.push({
                            name: 'Lead',
                            params: { ID: snapshot.data().mergedLead }
                        });
                    }else{
                        this.data = snapshot.data()
                        this.data.id = snapshot.id
                        
                        this.get_customer_stats()
                        
                        this.loaded = true
                        this.tabloaded = true
                    }
                        
                
                })
            
        },
        
        get_customer_stats( ){

            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }

            axios({ 
                method: 'POST', 
                url: 'https://sql.theatlass.com/api-v2/analyze/stats.php?query=customer-revenue', 
                headers: headers, 
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID ),
                    "leadID":  this.docID
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.data
                    //console.log(data)
                    this.data.revenue = data[0].revenue
                }
                
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        routePrimaryLead(ID){
            this.$router.push({
                name: 'LeadPage',
                params: { ID: ID }
            });
        }
    },
    computed:{
        userRole(){
            return this.$store.getters.getRole
        },
    },
    watch: {
        ID: function(){
            this.docID = this.ID
            this.get_data();
            
            this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/leads/Lead.vue